Modules.EmailSubscription.Helpers.Sessions = {
  getSessionKey: function() {
    return "subscription_coupons";
  }
};

module.exports = Modules.EmailSubscription.Helpers.Sessions;

